export const GET_NOTES = "notes/GET";
export const SET_NOTES = "notes/SET";
export const ADD_NOTE = "notes/ADD";
export const UPDATE_NOTE = "notes/EDIT";
export const REMOVE_NOTE = "notes/REMOVE";

export const GET_ATTACHMENTS = "attachments/GET";
export const SET_ATTACHMENTS = "attachments/SET";
export const ADD_ATTACHMENT = "attachments/ADD";
export const UPDATE_ATTACHMENT = "attachments/EDIT";
export const REMOVE_ATTACHMENT = "attachments/REMOVE";



// WEBPACK FOOTER //
// ./app/modules/shared/actionTypes.js